import { tryFetch, HttpMethod, type HttpResponse } from '@/services/http'
import type { MetricActionRequest, MetricDeliveryStatusRequest } from './dashboard.requests'
import type {
  MetricAction,
  MetricDeliveryStatusResponse,
  MetricSetting,
} from '../models/dashboard.model'
import type { MetricErrorCode } from '../types/dashboard.enums'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getMetricSettings = async (): Promise<HttpResponse<MetricSetting, MetricErrorCode>> =>
  await tryFetch<MetricSetting, MetricErrorCode>(HttpMethod.Get, BASE_URL, 'metric/settings', {
    view: true,
  })

const getMetricActions = async (
  body: MetricActionRequest,
): Promise<HttpResponse<MetricAction[], MetricErrorCode>> =>
  await tryFetch<MetricAction[], MetricErrorCode>(HttpMethod.Post, BASE_URL, 'metric/actions', {
    view: true,
    body,
  })

const getMetricDeliveryStatus = async (
  body: MetricDeliveryStatusRequest,
): Promise<HttpResponse<MetricDeliveryStatusResponse, MetricErrorCode>> =>
  await tryFetch<MetricDeliveryStatusResponse, MetricErrorCode>(
    HttpMethod.Post,
    BASE_URL,
    'metric/delivery-status',
    {
      view: true,
      body,
    },
  )

export const dashboardApi = {
  getMetricSettings,
  getMetricActions,
  getMetricDeliveryStatus,
}
